module.exports = __webpack_public_path__ + "static/media/development.2d3ad304.jpg";